import { Link, Navigate, useSearchParams } from "react-router-dom";
import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, Spinner } from "react-bootstrap";
import { Icon } from "@iconify/react/dist/iconify.js";
import { isEmpty } from "lodash";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Currency, { ConvertCurrency } from "../../../helpers/Currency/Currency";
import { verifyPaymentPublicContext } from "../../../context/PublicContext/VerifyPaymentPublicContext/VerifyPaymentPublicContext";
import {
  convertPaymentGatewayToText,
  paymentStatusItems,
} from "../../../utils/enum";

const VerifyPaymentPublic = () => {
  const user = useSelector((state) => state.user);
  const loader = useSelector((state) => state.loader);

  // Params
  const [searchParams] = useSearchParams();

  const authority = searchParams.get("Authority");

  const { message, payment, handleVerifyPayment } = useContext(
    verifyPaymentPublicContext
  );

  useEffect(() => {
    if (!!authority) handleVerifyPayment(authority);
  }, [authority]);

  if (!authority) return <Navigate to="/" replace />;
  if (loader)
    return (
      <>
        <SiteTitle title="بررسی پرداخت" />

        <Card className="my-5 container text-center">
          <div className="py-5">
            <Spinner
              variant="primary"
              animation="grow"
              className="text-center"
            />
          </div>
        </Card>
      </>
    );

  const isVerify = payment?.status === paymentStatusItems[0];

  return (
    <>
      <SiteTitle title="بررسی پرداخت" />
      <section className="my-5">
        <div className="container">
          <Card className="text-center">
            <CardBody className="py-5">
              {isVerify ? (
                <>
                  <div className="mb-5 text-center">
                    <Icon
                      icon="solar:check-circle-broken"
                      className="display-1 text-success"
                    />
                  </div>
                  {!isEmpty(user) && (
                    <h6 className="fw-bold text-success">
                      {user.firstName} {user.lastName} عزیز،
                    </h6>
                  )}
                  <h4 className="text-success font-weight-bold">
                    {message || "پرداخت شما با موفقیت ثبت گردید."}
                  </h4>
                </>
              ) : (
                <>
                  <div className="mb-5 text-center">
                    <Icon
                      icon="solar:close-circle-broken"
                      className="display-1 text-danger"
                    />
                  </div>
                  {!isEmpty(user) && (
                    <h6 className="fw-bold text-danger">
                      {user.firstName} {user.lastName} عزیز،
                    </h6>
                  )}
                  <h4 className="text-danger font-weight-bold">
                    {message || "متاسفانه پرداخت شما ناموفق بود!"}
                  </h4>
                  <p className="text-danger">
                    <i className="fa fa-info-circle fa-1_5x mr-3" /> این پرداخت
                    تایید نهایی نشده. جهت تایید نهایی نسبت به پرداخت مجدد اقدام
                    نمایید
                  </p>
                </>
              )}
              <br />
              <Link
                to="/"
                className="py-8 px-5 border border-primary-200 bg-primary-50 bg-hover-primary-100 radius-12"
              >
                بازگشت به صفحه اصلی
              </Link>
            </CardBody>
          </Card>

          <div className="card mt-5">
            <div className="card-body">
              {!isVerify && (
                <p className="text-muted d-flex align-items-center">
                  <Icon
                    icon="solar:info-circle-broken"
                    className="text-info ms-3"
                  />{" "}
                  چنانچه مبلغی از حساب شما کسر شده است، تا ۲۴ ساعت آینده به حساب
                  شما باز خواهد گشت.
                </p>
              )}
              {!isEmpty(payment) && (
                <div className="d-flex align-items-center">
                  <div>
                    <Icon
                      icon={
                        isVerify
                          ? "solar:check-circle-broken"
                          : "solar:close-circle-broken"
                      }
                      className={isVerify ? "text-success" : "text-danger"}
                    />
                  </div>
                  <div className="d-flex me-3">
                    <div className="ms-5">
                      <p className="text-muted mb-4">مبلغ</p>
                      <p>
                        <ConvertCurrency price={payment?.amount} /> <Currency />
                      </p>
                    </div>
                    <div className="ms-5">
                      <p className="text-muted mb-4">درگاه</p>
                      <p>{convertPaymentGatewayToText(payment?.gateway)}</p>
                    </div>
                    <div className="ms-5">
                      <p className="text-muted mb-4">شماره پیگیری</p>
                      <p>{payment?.trackingCode}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VerifyPaymentPublic;
